import { IPediatricHistory } from "../../resources-vue/vue-interfaces/i-health";

export class PediatricHistory implements IPediatricHistory {
    public tbTest: boolean = null;
    public leadScreening: boolean = null;
    public otherPediatricScreening: string = "";
    public newBornHistory: boolean = false;
    public gestationalAgeAtBirth: string = "";
    public lengthAtBirth: null;
    public lengthScale: number = 0;
    public newBornScreeningResult: string = "";
    public birthWeight: null;
    public birthWeightScale: number = 0;
    public headCircumference: null;
    public headCircumferenceScale: number = 0;
    public fontanels: number[] = [];
    public umbilicus: number[] = [];

    public constructor(data?: IPediatricHistory) {
        if (!!data) {
            Object.assign(this, data);
        }
    }
}
